module.exports = __webpack_public_path__ + "img/passage3d-small-dark.e265ce98.svg";